define('flight-components/Account',[
  'App',
  'flight/lib/component',
  'URIjs/URI',
  'cookies',
  'vendor/jquery.form'
],

function(App, defineComponent, URI) {

  var Account = function Account() {

    this.defaultAttrs({
      changePasswordSelector: '[data-triggers="changePassword"]',
      profileSelector: '[data-triggers="profile"]',
      signOutSelector: '[data-triggers="signOut"]',

      oneClickOptinSelector: '[data-triggers="oneClickOptin"]',
      dismissHeroSelector: '[data-triggers="memberHeroDismiss"]',
      optedInSelector: '[data-triggers="optedIn"]',
      optInConfirmReq: '[data-triggers="optInConfirmReq"]',

      profileVoucherlink: '[data-triggers="profileVoucherlink"]',
      profileBacklink: '[data-triggers="profileBacklink"]',

      contactUsSelector: '[data-triggers="contactUs"]',
      contactFranchisingSelector: '[data-triggers="contactFranchising"]',

      ccpaRequestInfoSelector: '[data-triggers="ccpaRequestInfo"]',
      ccpaDoNotSellSelector: '[data-triggers="ccpaDoNotSell"]'
    });

    /* Profile helper function */
    this.profileHelper = function(action) {
      if (action == 'parse') {
        // Parse dob fields
        var dob = $("#dateOfBirth").val();
        var dobPart = dob.split("/");

        $("#dobMonth").val(dobPart[0]);
        $("#dobDay").val(dobPart[1]);
        $("#dobYear").val(dobPart[2]);
      }
      else {
        // Combine dob fields
        var dobMonth = $("#dobMonth").val();
        var dobDay = $("#dobDay").val();
        var dobYear = $("#dobYear").val();

        if (dobMonth != '' && dobDay != '' && dobYear != '') {
          $("#dateOfBirth").val(dobMonth + '/' + dobDay + '/' + dobYear);
        }
        else {
          $("#dateOfBirth").val('12/31/2000');
        }
      }
    };

    /* Back to profile - for mobile */
    this.profileBacklink = function(ev) {
      ev.preventDefault();

      // Show profile
      $("#profile").show();

      // Empty voucher display
      $("#mobileVoucher").html('');
    };

    /* Sign out from account */
    this.signOut = function(ev) {
      ev.preventDefault();

      // Set user var
      App.user.isLoggedIn = false;

      // Sign out from Valpak
      location.href = App.server + App.context + '/signOut';
    };

    /* One click member opt-in */
    this.oneClickOptin = function(ev) {
      var successMsg = "<h4 class='icon-check h4'>You're all set!</h4> <p>Please check your email inbox for your confirmation email.</p>";
      var errorMsg = "<h4 class='icon-attention h4'>Oops!</h4> <p>Our e-mailman must be on break. Please try again later.</p>";

      ev.preventDefault();

      $.ajax({
        url: App.context + '/member/optInMember',
        dataType: "json",
        data: {userId: App.user.memberId},
        success: function(resp) {
          // Replace content
          $(".form__partial").replaceWith(resp.content);

          // Swap button for message
          $(".optinMsg").hide().html(successMsg).fadeIn('slow');
        },
        error: function() {
          // Swap button for message
          $(".optinMsg").hide().html(errorMsg).fadeIn('slow');
        }
      });
    };

    /* Dismiss hero from account profile page */
    this.dismissHero = function(ev) {
      // ev.preventDefault();

      // Set memberHero cookie
      $.cookie('memberHero', true, {expires:180, path:'/'});

      $(".optinMsg").parent().remove();
    };


    var i = 0;
//    var optedInValue_original = $('[name=optedIn]').val();
//    var optInConfirmReq_original = $('[name=optInConfirmReq]').val();
    /* Email opt-in */
    this.optedIn = function(ev) {
      var $el = $(ev.target);
      var optedInValue = $el.val();
      var optInConfirmReq = $('[name=optInConfirmReq]').val();
      //ev.preventDefault();

       if(optedInValue == 'false' && optInConfirmReq == 'false'){
         $el.attr({value: 'false', checked: true});
         $('[name=optInConfirmReq]').val("true");
       } else if(optedInValue == 'true' && optInConfirmReq == 'false'){
         $el.attr({value: 'false', checked: false});
         $('[name=optInConfirmReq]').val("false");
       } else {
           $el.attr({value: 'false', checked: false});
           $('[name=optInConfirmReq]').val("false");
      }
       i++;

       if ( (i % 2) == 0){
         $el.val(optedInValue_original);
         $('[name=optInConfirmReq]').val(optInConfirmReq_original);
         $('[name=optedIn]').val(optedInValue_original);
       }


    };

    /* Form access manager */
    this.formAccess = function(ev) {
      var $el = $(ev.target);
      var action = $el.data('triggers');

      ev.preventDefault();

      if (action == 'profile') {
        // Remove temp password session cookie
        $.cookie('tempPassword', null, {path:'/'});
      }

      // Redirect to action request
      if (action == 'ccpaRequestInfo') {
        location.href = App.context + '/ccpa?form=requestInfo';
      }
      else if (action == 'ccpaDoNotSell') {
        location.href = App.context + '/ccpa?form=doNotSell';
      }
      else {
        location.href = App.context + '/' + action;
      }
    };

    /* Form init */
    this.formInit = function() {
      var self = this;

      // Ajax form submission
      if (App.page === 'profile') {
        this.profileHelper('parse');

        $('#' + App.page + 'Form').ajaxForm({
          dataType: 'json',
          success: function(responseText, statusText, xhr, $form) {
            self.formSubmit(responseText, statusText, xhr, $form);
          },
          beforeSerialize: this.profileHelper
        });

        // Remove temp password session cookie
        $.cookie('tempPassword', null, {path:'/'});
      }
      else {
        $('#' + App.page + 'Form').ajaxForm({
          dataType: 'json',
          success: function(responseText, statusText, xhr, $form) {
            self.formSubmit(responseText, statusText, xhr, $form);
          }
        });
      }
    };

    /* Form submit handler */
    this.formSubmit = function(responseText, statusText, xhr, $form) {
      // Replace content
      $(".form__partial").replaceWith(responseText.content);

      if (responseText.status == 'error') {
        // Display form errors
        formErrorHandler();
      }
      else {
        // if current url has redirectUrl param it should
        // override the response data redirectUrl
        var currentUrl = URI(window.location.href);

        if (currentUrl.hasSearch('redirectUrl')) {
          window.location.href = currentUrl.search(true).redirectUrl;
          return;
        }

        if (responseText.redirectUrl != null) {
          if (App.page == 'forgotPassword') {
            // Set temp password session cookie
            $.cookie('tempPassword', true, {path:'/'});
          }

          // Use redirect url
          if (App.page == 'changePassword' || App.page == 'profile') {
            location.href = App.context + '/' + responseText.redirectUrl + '?success=true';
          }
          else {
            location.href = App.context + '/' + responseText.redirectUrl;
          }
        }
        else {
          // Reload page
          location.href = App.context + '/' + App.page + '?success=true';
        }
      }
    };

    /* Form field error handler */
    function formErrorHandler() {
      // Transfer error value to placeholder
      $('input:not([type*="checkbox"],[type*="hidden"]),select,textarea').each(function() {
        if ($(this).attr('data-error') != '') {
          $(this).attr('placeholder', $(this).attr('data-error'));
          // Clear value to allow placeholder to show
          $(this).val('');
        }
      });

      // Transfer field value on focus
      $('input:not([type*="checkbox"],[type*="hidden"]),select,textarea').on('focus', function() {
        if ($(this).val() == '') {
          $(this).val($(this).attr('data-value'));
        }
      });
    };

    this.after('initialize', function() {
      var self = this;

      this.on('click', {
        'changePasswordSelector': this.formAccess,
        'profileSelector': this.formAccess,
        'signOutSelector': this.signOut,

        'oneClickOptinSelector': this.oneClickOptin,
        'dismissHeroSelector': this.dismissHero,
        'optedInSelector': this.optedIn,
        'profileVoucherlink': this.formAccess,
        'profileBacklink': this.profileBacklink,

        'contactUsSelector': this.formAccess,
        'contactFranchisingSelector': this.formAccess,

        'ccpaRequestInfoSelector': this.formAccess,
        'ccpaDoNotSellSelector': this.formAccess
      });

      this.formInit();
    });

  };

  return defineComponent(Account);

});

